import { FC } from 'react';
import * as React from 'react';

import { css } from 'styled-components';

import { useTranslation } from '@crehana/i18n';
import { CustomNextImage as Image } from '@crehana/next';

import { AnimatedWrapper } from './SocialNotification.styles';
import { SocialNotificationPortalProps } from './types';

const SocialNotification: FC<
  React.PropsWithChildren<SocialNotificationPortalProps>
> = ({ open, company }) => {
  const { t } = useTranslation();

  if (!company) {
    return null;
  }

  return (
    <AnimatedWrapper
      open={open}
      className="flex items-center bg-white z-9 fixed"
      style={{
        width: 350,
        height: 80,

        bottom: 32,
        borderRadius: 100,
      }}
      css={css`
        left: 4px;
        @media (min-width: 768px) {
          left: 32px;
        }
      `}
    >
      <div
        className="w-80 h-80 rounded-full flex justify-center items-center bg-white overflow-hidden border-solid p-12"
        style={{ borderColor: '#E3E4E5', borderWidth: 1 }}
      >
        <Image
          src={company?.image || ''}
          alt={company?.name}
          objectFit="contain"
          layout="intrinsic"
          height={80}
          width={80}
        />
      </div>
      <div className="p-12">
        <p className="font-poppins font-semibold text-16 mb-4">
          {company?.name}
        </p>
        <p className="font-poppins font-normal text-14 mb-4">
          {t('SOCIAL_NOTIFICATION_TITLE')}
        </p>
      </div>
    </AnimatedWrapper>
  );
};

export default SocialNotification;
